import React, { ReactElement } from 'react';
import MuiFormControl, {
  FormControlProps as MuiFormControlProps,
  FormControlTypeMap
} from '@material-ui/core/FormControl';
import { Uds } from '../../types';

export type FormControlProps<D extends React.ElementType = FormControlTypeMap['defaultComponent'], P = {}> = Uds<
  MuiFormControlProps<D, P>
>;

export const FormControl = <D extends React.ElementType = FormControlTypeMap['defaultComponent'], P = {}>({
  dataTest,
  children,
  ...props
}: FormControlProps<D, P>): ReactElement => (
  <MuiFormControl {...props} data-test={dataTest}>
    {children}
  </MuiFormControl>
);
